// packages
import { max, sum } from 'd3-array';

// components
import Collection from './Collection.svelte';

// local
import diff from '../../utils/diff';
import { last } from '../../utils/last';
import { movingAverage } from '../../utils/moving-average';

// what our percent change needs to be within to be considered "stable"
const threshold = 0.15;

// gonna do this a lot
function perCapita(numerator, denominator) {
  return (numerator / denominator) * 100000;
}

export default function countyCompare(
  data,
  targetId,
  labelUnit,
  getChartTitle
) {
  const all = [];

  let globalMax = {
    new_confirmed_and_probable_cases_total: 0,
    new_confirmed_deaths_total: 0,
    new_confirmed_and_probable_cases_per_100k: 0,
    new_confirmed_deaths_per_100k: 0,
  };

  data.forEach((d) => {
    // Calculate percapita numbers
    d.new_confirmed_and_probable_cases_per_100k = d.new_confirmed_and_probable_cases_timeseries.map(
      (c) => perCapita(c, d.population)
    );
    d.new_confirmed_deaths_per_100k = d.new_confirmed_deaths_timeseries.map(
      (c) => perCapita(c, d.population)
    );

    d.new_confirmed_and_probable_cases_seven_day_per_100k = perCapita(
      d.new_confirmed_and_probable_cases_seven_day_total,
      d.population
    );
    d.new_confirmed_deaths_seven_day_per_100k = perCapita(
      d.new_confirmed_deaths_seven_day_total,
      d.population
    );

    // Run the averages
    d.averages = {
      new_confirmed_and_probable_cases_total: movingAverage(
        d.new_confirmed_and_probable_cases_timeseries,
        7
      ),
      new_confirmed_and_probable_cases_per_100k: movingAverage(
        d.new_confirmed_and_probable_cases_per_100k,
        7
      ),
      new_confirmed_deaths_total: movingAverage(
        d.new_confirmed_deaths_timeseries,
        7
      ),
      new_confirmed_deaths_per_100k: movingAverage(
        d.new_confirmed_deaths_per_100k,
        7
      ),
    };

    // Check if it sets our new max value
    const maxCases = max(d.averages.new_confirmed_and_probable_cases_total);
    if (maxCases > globalMax.new_confirmed_and_probable_cases_total) {
      globalMax.new_confirmed_and_probable_cases_total = maxCases;
    }

    const maxDeaths = max(d.averages.new_confirmed_deaths_total);
    if (maxDeaths > globalMax.new_confirmed_deaths_total) {
      globalMax.new_confirmed_deaths_total = maxDeaths;
    }

    const maxCases100k = max(
      d.averages.new_confirmed_and_probable_cases_per_100k
    );
    if (maxCases100k > globalMax.new_confirmed_and_probable_cases_per_100k) {
      globalMax.new_confirmed_and_probable_cases_per_100k = maxCases100k;
    }

    const maxDeaths100k = max(d.averages.new_confirmed_deaths_per_100k);
    if (maxDeaths100k > globalMax.new_confirmed_deaths_per_100k) {
      globalMax.new_confirmed_deaths_per_100k = maxDeaths100k;
    }

    // Add it to the list we're going to keep
    all.push(d);
  });

  return function render() {
    new Collection({
      target: document.getElementById(targetId),
      props: {
        data: all.sort(
          (a, b) =>
            b.new_confirmed_and_probable_cases_seven_day_per_100k -
            a.new_confirmed_and_probable_cases_seven_day_per_100k
        ),
        globalMax,
        labelUnit,
        getChartTitle,
        locale: document.documentElement.lang,
      },
    });
  };
}
